export const AVAILABLE_FONTS = [
    // Web-safe fonts
    "Arial",
    "Verdana",
    "Helvetica",
    "Times New Roman",
    "Trebuchet MS",
    "Georgia",
    "Garamond",
    "Courier New",
    "Lucida Console",
    "Comic Sans MS",
    "Tahoma",
    "Palatino Linotype",
    "Inter var, sans-serif",
  
    // Generic font families
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
  
    // System-specific fonts
    "Segoe UI", // Windows
    "SF Pro Text", // macOS and iOS
    "Roboto", // Android
    "Ubuntu", // Linux
    "Cantarell", // Linux GNOME
    "Monaco" // macOS monospace
  ];
  
  export const DEFAULT_FONT = "Arial";